import KeyboardHint from "ds/components/KeyboardHint";
import ModalFooter from "ds/components/Modal/Footer";
import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import Box from "ds/components/Box";

const CommandPaletteFooter = () => {
  const currentView = useCommandPaletteStore((state) => state.currentView);

  const escLabel = currentView === "main" ? "Close" : "Go Back";

  return (
    <ModalFooter>
      <Box gap="large">
        <KeyboardHint keys="↑↓" label="Navigate" />
        <KeyboardHint keys="↵" label="Select" />
        <KeyboardHint keys="ESC" label={escLabel} />
      </Box>
    </ModalFooter>
  );
};

export default CommandPaletteFooter;
